import React from 'react';
import { useTranslation } from 'react-i18next';
import { NsKey } from 'enums/NsKey';
import RadioButtonChoice, { Sizes } from 'components/domain/ProfilingForm/RadioButtonChoice';
import { PossibleAnswer, Question } from '../types/interfaces';

interface ProfilingQuestionProps {
  question: Question;
  currentAnswers: PossibleAnswer[];
  onAnswer: (key: string, answer: PossibleAnswer[]) => void;
}

export const ProfilingQuestion: React.FC<ProfilingQuestionProps> = ({
  question,
  currentAnswers,
  onAnswer
}) => {
  const { t } = useTranslation(NsKey.Profiling)
  return (
    <div className="flex flex-col gap-6 items-center justify-center">
      <div className='flex flex-col gap-2 justify-center items-center'>
        <p className="text-xl text-center text-zinc-800 font-medium">
          {question.label}
        </p>
        <p className='text-zinc-500'>
          {t("PROFILING_QUESTION.CHECK_CORRECT_ANSWER")}
        </p>
      </div>
      <div className="flex gap-4">
        <RadioButtonChoice
          key={question.key + "true"}
          size={Sizes.lg}
          radio
          text="Oui"
          selected={currentAnswers[0] === true}
          handleOnClick={() => onAnswer(question.key, [true])}
        />
        <RadioButtonChoice
          key={question.key + "false"}
          size={Sizes.lg}
          radio
          text="Non"
          selected={currentAnswers[0] === false}
          handleOnClick={() => onAnswer(question.key, [false])}
        />
      </div>
    </div>
  );
};
